// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: Forma DJR Micro;
    src: url('https://zakekecdn.blob.core.windows.net/cdn/Content/fonts/FormaDJRMicro-Regular.ttf');
}

html.new-backoffice,
body.new-backoffice {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    color: #263238;
}

html.new-backoffice .notifications-component,
body.new-backoffice .notifications-component {
    top: 0;
    left: 0;
}

html.new-backoffice .rnc__notification-container-top-right,
body.new-backoffice .rnc__notification-container-top-right {
    position: fixed !important;
}

html.new-backoffice .notification__item,
body.new-backoffice .notification__item {
    opacity: 0;
}

body {
    overflow-y: scroll;
}

body:not(.login-page, .admin-page) {
    padding-top: 0;
}

* {
    box-sizing: border-box;
}

.rnc__notification-item {
    opacity: 0;
}

.notification__message a {
    color: white !important;
}

.rnc__base {
    top: 0;
    left: 0;
}

/* RTE Tiny Cloud warning message */
.tox-notification--warning {
    display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,+FAA+F;AACnG;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,eAAe;IACf,gCAAgC;IAChC,cAAc;AAClB;;AAEA;;IAEI,MAAM;IACN,OAAO;AACX;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,MAAM;IACN,OAAO;AACX;;AAEA,mCAAmC;AACnC;IACI,wBAAwB;AAC5B","sourcesContent":["@font-face {\n    font-family: Forma DJR Micro;\n    src: url('https://zakekecdn.blob.core.windows.net/cdn/Content/fonts/FormaDJRMicro-Regular.ttf');\n}\n\nhtml.new-backoffice,\nbody.new-backoffice {\n    margin: 0;\n    padding: 0;\n    font-size: 14px;\n    font-family: 'Inter', sans-serif;\n    color: #263238;\n}\n\nhtml.new-backoffice .notifications-component,\nbody.new-backoffice .notifications-component {\n    top: 0;\n    left: 0;\n}\n\nhtml.new-backoffice .rnc__notification-container-top-right,\nbody.new-backoffice .rnc__notification-container-top-right {\n    position: fixed !important;\n}\n\nhtml.new-backoffice .notification__item,\nbody.new-backoffice .notification__item {\n    opacity: 0;\n}\n\nbody {\n    overflow-y: scroll;\n}\n\nbody:not(.login-page, .admin-page) {\n    padding-top: 0;\n}\n\n* {\n    box-sizing: border-box;\n}\n\n.rnc__notification-item {\n    opacity: 0;\n}\n\n.notification__message a {\n    color: white !important;\n}\n\n.rnc__base {\n    top: 0;\n    left: 0;\n}\n\n/* RTE Tiny Cloud warning message */\n.tox-notification--warning {\n    display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
